"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var types_1 = require("../types");
var CustomerAPI = /** @class */ (function () {
    function CustomerAPI(client) {
        this.client = client;
    }
    CustomerAPI.prototype.updateCustomerSubscriptions = function (customerId, brandId, subscriptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.put("/customers/".concat(customerId, "/brands/").concat(brandId, "/subscriptions"), subscriptions)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerAPI.prototype.updateCustomer = function (customerId, params) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.patch("/customers/".concat(customerId), params)];
                    case 1:
                        data = _d.sent();
                        return [2 /*return*/, {
                                data: data,
                            }];
                    case 2:
                        err_1 = _d.sent();
                        if (axios_1.default.isAxiosError(err_1) &&
                            (0, types_1.isErrorWithMessage)((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.data) &&
                            ((_b = err_1.response) === null || _b === void 0 ? void 0 : _b.data.message)) {
                            return [2 /*return*/, { error: (_c = err_1.response) === null || _c === void 0 ? void 0 : _c.data.message }];
                        }
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerAPI.prototype.subscribe = function (customerId, brandId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post("/customers/".concat(customerId, "/brands/").concat(brandId, "/subscribe"), undefined)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.unsubscribe = function (customerId, brandId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post("/customers/".concat(customerId, "/brands/").concat(brandId, "/unsubscribe"), undefined)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.setSource = function (customerId, brandId, source) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post("/customers/".concat(customerId, "/brands/").concat(brandId, "/source"), { source: source })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.getPaymentMethods = function (customerID, locationID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/customers/".concat(customerID, "/locations/").concat(locationID, "/payment-methods"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerAPI.prototype.updatePaymentMethods = function (customerID, locationID, newPaymentMethods) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.put("/customers/".concat(customerID, "/locations/").concat(locationID, "/payment-methods"), newPaymentMethods)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerAPI.prototype.getBrandLoyaltyPoints = function (customerID, brandID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/customers/".concat(customerID, "/brands/").concat(brandID, "/points"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerAPI.prototype.getEligibleCoupons = function (customerID, locationID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/customers/".concat(customerID, "/locations/").concat(locationID, "/coupons"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Checks if user is subscribed to marketing emails.
     *
     * @param customerId ID of customer to check
     * @param brandId Brand of location to check for
     * @returns True if customer is subscribed to emails
     */
    CustomerAPI.prototype.getSubscriptions = function (customerId, brandId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.get("/customers/".concat(customerId, "/brands/").concat(brandId, "/subscriptions"))];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, data.subscriptions];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, {
                                email: false,
                                sms: false,
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerAPI.prototype.getCustomer = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/customers/".concat(customerId))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.listCustomers = function (brandId_1, _a) {
        return __awaiter(this, arguments, void 0, function (brandId, _b) {
            var data;
            var phone = _b.phone;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.client.get("/brands/".concat(brandId, "/customers"), {
                            phone: phone,
                        })];
                    case 1:
                        data = _c.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.createCustomer = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post("/customers", body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.getReferral = function (customerId, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/customers/".concat(customerId, "/locations/").concat(locationId, "/referral"))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CustomerAPI.prototype.updateFirebaseToken = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var customerId = _b.customerId, brandId = _b.brandId, registrationToken = _b.registrationToken, created = _b.created;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.client.post("/customers/".concat(customerId, "/brands/").concat(brandId, "/fcm-token"), {
                            registrationToken: registrationToken,
                            created: created,
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    CustomerAPI.prototype.removeFirebaseToken = function (customerId, brandId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.delete("/customers/".concat(customerId, "/brands/").concat(brandId, "/fcm-token"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CustomerAPI;
}());
exports.default = CustomerAPI;
//# sourceMappingURL=index.js.map